window.onload = function () {
    var $video_play = $(".template-product .cstm-varient-image-jtpl.gang__active button.deferred-media__poster span.deferred-media__poster-button");
    
    if ($video_play.length > 0) {
        $video_play[0].click(); 
        var $videoElement = $(".template-product .cstm-varient-image-jtpl.gang__active video");
        if ($videoElement.length > 0) {
            $videoElement[0].play(); 
        }
    }
}
$("body").on("click", ".product_wrapper_jtpl .cstm-variant-selector-jtpl .selected-swatch-navbar", function() {
  var $this = $(this);
  $this.find('.swatch-selected-color-navbar').toggleClass('ul-active');
  $this.closest('.swatch-grid-color-wrapper-main').find('.swatch-list-navbar-jtpl').toggleClass('div-active');
});

function slideFreeGift2(){
    var timeinterval = setInterval(function(){            
               if($('.gift_item').length==0){
                 $('.spend-get-gift').hide();clearInterval(timeinterval);}else{
                 $('.spend-get-gift').show();
                  if($('.free-sample-main-section').length>0 && $(window).width() > 750){ 
                    $('.free-sample-products').attr("style","display:none");
                        $('.main-headingcontent-jtpl').addClass('close');
                 }
                  if($(window).width() < 750){
                      if($('.free-sample-main-section').length>0){ 
                         $('.free-sample-products').attr("style","display:none");
                        $('.main-headingcontent-jtpl').addClass('close');
                       // $('.free-sample-main-section .main-headingcontent-jtpl').trigger("click");
                     }
                 }
                   clearInterval(timeinterval);
               }  
             },500);
}


$(document).ready(function () {

  /********************New-PDP-Grid AND LIST JS**************************/
$(".cstm_use-animate.only-for-hide-purpose-not-use").hide(); 
  
if($("body").hasClass("template-product")){
    var currentUrl = window.location.href;
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get("variant");
  
if (variantId) {
   console.log(variantId + ' variantId');

  let listTitle = [];

  $('.product__info-container .variant-input-wrapper .swatch-grid-style-only').find('.swatch-grid-color-wrapper input').each(function () {
      var title = $(this).attr('variant_id'); 
      if (title) {
        listTitle.push(title);
      }
    });

   console.log('listTitle:', listTitle);

  let matchIndex = listTitle.indexOf(variantId);
   console.log(matchIndex + 'matchIndex');

  $(".product__info-container .variant-input-wrapper .swatch-grid-style-only .swatch-grid-color-wrapper .color__swatch.color__swatch--round").eq(matchIndex).trigger("click");
  $(".product__info-container .variant-input-wrapper .swatch-grid-style-only .swatch-grid-color-wrapper label").eq(matchIndex).trigger("click").addClass("label-active");
  $(".product__info-container .variant-input-wrapper .swatch-grid-style-only .swatch-grid-color-wrapper input").eq(matchIndex).trigger("click");
}
else {
    $(".swatch-grid-style-only .swatch-grid-color-wrapper .color__swatch.color__swatch--round").eq(0).trigger("click");
    $(".swatch-grid-style-only .swatch-grid-color-wrapper input").eq(0).trigger("click");
    $(".swatch-grid-style-only .swatch-grid-color-wrapper label").eq(0).trigger("click").addClass("label-active");
 }
}
  
var shopify_videos = document.getElementsByClassName('cstm_shopify_video');
if (shopify_videos.length > 0) {
  // alert('hyehy');
  for (var i = 0; i < shopify_videos.length; i++) {
    shopify_videos[i].play().catch(function(error) {
      console.error('Video playback failed:', error);
    });
  }
}
  
$(".cstm-varient-image-jtpl.youtube-video-pdp.cstm-yt-video").show();  
var li_Html= $(".swatch-list-color-wrapper li.swatch-varaint-jtpl").eq(0).html();
$(".swatch-color-selected-show .swatch-selected-color li").html(li_Html);   
$("body").on("click",".legend-grid-list-wrapper .swatch-grid-style", function(){
   $(".swatch-list-style-only").hide();
   $(".swatch-grid-style-only").show();
   $(this).addClass("active");
   $(this).removeClass("inactive");
   $(".legend-grid-list-wrapper .swatch-list-style").removeClass("active");
   $(".legend-grid-list-wrapper .swatch-list-style").addClass("inactive");
   var swatch_title = $(".form__label-info").text().trim();
var swatch_title_new = swatch_title.split("–")[1]?.trim();
   // console.log("title_tobe_search="+swatch_title_new);
   $('.swatch-grid-color-wrapper').each(function() {
  $(this).find(".color__swatch.color__swatch--round").each(function() {
    var title_var = $(this).attr("title");
    if(swatch_title_new == title_var){
     $(this).addClass("label-active");
    }
    
  });
}); 
 });
$("body").on("click",".legend-grid-list-wrapper .swatch-list-style", function(){
$(".swatch-list-style-only").show();
var swatch_title = $(".legendinner .form__label-info").text().trim();
var swatch_title_new = swatch_title.split("–")[1]?.trim();
//    console.log("title_tobe_search="+swatch_title_new);
 // alert("...to-be contineue");
   $('.swatch-list-color-wrapper').each(function() {
  $(this).find(".swatch-varaint-jtpl").each(function() {
    var title_var = $(this).find(".color__swatch.color__swatch--round").attr("title");
   // alert("title_var"+title_var+"swatch_title_new"+swatch_title_new);
    if(swatch_title_new == title_var){
     //$(this).find("label").addClass("label-active");
    var new_htl_append = $(this).html();
    //  alert("...."+swatch_title_new +"..."+title_var);
    //$(".swatch-color-selected-show .swatch-selected-color li").html(new_htl_append);
     $(this).closest(".swatch-list-style-only").find(".swatch-color-selected-show .swatch-selected-color li").html(new_htl_append);
     $(this).closest(".swatch-list-style-only").find(".swatch-color-selected-show ul.swatch-selected-color li label").addClass("label-active");
    }
  });
});
    $(".swatch-grid-style-only").hide(); 
   $(this).addClass("active");
   $(this).removeClass("inactive");
   $(".legend-grid-list-wrapper .swatch-grid-style").removeClass("active"); 
   $(".legend-grid-list-wrapper .swatch-grid-style").addClass("inactive");  
 }); 
$("body").on("click",".swatch-selected-color",function(){
 $(this).toggleClass("active");
 $(".swatch-list-color-main-jtpl").fadeIn();
 $(".swatch-list-color-main-jtpl").toggleClass("is-active");
});
$("body").on("click",".swatch-list-color-wrapper li.swatch-varaint-jtpl .swatch-color-title-jtpl", function(e){
var li_Html= $(this).parents(".swatch-varaint-jtpl").html();
  //alert("li_Html"+li_Html);
$(this).parents(".swatch-varaint-jtpl").find(".color__swatch.color__swatch--round").trigger("click");
var title_add = $(this).parents(".swatch-varaint-jtpl").find(".color__swatch.color__swatch--round").attr("title");
//console.log("title_add"+title_add); 
  var append_title ="– "+title_add; 
//console.log(append_title); 
 //$(".form__label-info").text(append_title); 
  $(this).closest(".product-form__input").find(".form__label-info").text(append_title);
setTimeout(function() {  
//  $(".swatch-color-selected-show .swatch-selected-color li").html(li_Html);
 $(this).closest(".swatch-list-style-only").find(".swatch-color-selected-show ul.swatch-selected-color li").html(li_Html);
  },500);
$(".swatch-list-color-main-jtpl.is-active").removeClass("is-active");
$(".swatch-color-selected-show .swatch-selected-color.active").removeClass("active");  
});
  
if ($(".cstm-varient-image-jtpl.youtube-video-pdp.cstm-yt-video").length > 0) {
    $(".cstm-varient-image-jtpl.youtube-video-pdp.cstm-yt-video").each(function () {
        var html_video = $(this).prop("outerHTML");
        $(this).remove();
        $(".cstm-jtpl-grid .cstm-grid-wrapper-jtpl li").eq(0).after(html_video);
    });
} else if ($(".cstm-varient-image-jtpl.youtube-video-pdp.pro-video-jtpl").length > 0) {
    var $video = $(".cstm-varient-image-jtpl.youtube-video-pdp.pro-video-jtpl").first();
    var html_video = $video.prop("outerHTML");
    $video.remove();
    $(".cstm-jtpl-grid .cstm-grid-wrapper-jtpl li").eq(0).after(html_video);
}
  
 $("body").on("click",".swatch-grid-style-only .swatch-grid-color-wrapper .color__swatch.color__swatch--round,.swatch-list-color-wrapper li.swatch-varaint-jtpl",function(){
  //************ variantIngredients text start  ****************/
    if($(this).hasClass("color__swatch--round")){
        var variantIngredients = $(this).attr("product-ingredients");
    }else{
        var variantIngredients = $(this).find("label").attr("product-ingredients");
    }
    if(variantIngredients){
      $(".custom-tab-wrapper-jtpl .content .cstm-tab-content-jtpl").eq(1).html(variantIngredients);
    }
 //************ variantIngredients text start  ****************/ 
  setTimeout(function() {
  if ($(".cstm-varient-image-jtpl.youtube-video-pdp.cstm-yt-video").length > 0) {
            $(".cstm-varient-image-jtpl.youtube-video-pdp.cstm-yt-video").each(function () {
                var html_video = $(this).prop("outerHTML");
                $(this).remove();
                $(".cstm-jtpl-grid .cstm-grid-wrapper-jtpl li").eq(0).after(html_video);
            });
        } else if ($(".cstm-varient-image-jtpl.youtube-video-pdp.pro-video-jtpl").length > 0) {
            var $video = $(".cstm-varient-image-jtpl.youtube-video-pdp.pro-video-jtpl").first();
            var html_video = $video.prop("outerHTML");
            $video.remove();
            $(".cstm-jtpl-grid .cstm-grid-wrapper-jtpl li").eq(0).after(html_video);
        }
   var product_badge = $(".cstm-jtpl-grid .badge-custom-wrapper").html();
 // console.log("batch_badge"+product_badge);
 if($(".hide-single-badge").length <=0){  
 $(".cstm-jtpl-grid .cstm-grid-wrapper-jtpl li.cstm-varient-image-jtpl:eq(0) use-animate .product__media").after(product_badge);
 $(".cstm-jtpl-grid .cstm_use-animate.custom-jtpl-mobile-version ul li:eq(0) use-animate .product__media").after(product_badge); 
 }
 }, 5); 
$(".swatch-grid-style-only .swatch-grid-color-wrapper .color__swatch.color__swatch--round.label-active").removeClass("label-active");    
$(this).addClass("label-active");
 });
  var product_badge = $(".cstm-jtpl-grid .badge-custom-wrapper").html();
// console.log("batch_badge"+product_badge);
if($(".hide-single-badge").length<=0){
 $(".cstm-jtpl-grid .cstm-grid-wrapper-jtpl li.cstm-varient-image-jtpl:eq(0) use-animate .product__media").after(product_badge);
 $(".cstm-jtpl-grid .cstm_use-animate.custom-jtpl-mobile-version ul li:eq(0) use-animate .product__media").after(product_badge); 
}
  $("body").on("click",".swatch-varaint-jtpl .color__swatch.color__swatch--round",function(){
   var li_Html= $(this).parents(".swatch-varaint-jtpl").html();
  $(this).closest(".swatch-list-style-only").find(".swatch-color-selected-show ul.swatch-selected-color li").html(li_Html);
   var title_add = $(this).parents(".swatch-varaint-jtpl").find(".color__swatch.color__swatch--round").attr("title");
//console.log("title_add"+title_add); 
  var append_title ="– "+title_add; 
//console.log(append_title); 
 $(this).closest(".form__label-info").text(append_title); 
   $(".swatch-list-color-main-jtpl.is-active").removeClass("is-active");
$(".swatch-color-selected-show .swatch-selected-color.active").removeClass("active");  
 });
$("body").on("click",".swatch-grid-style-only .swatch-grid-color-wrapper .color__swatch.color__swatch--round",function(){
  var title_add = $(this).attr("title");
  var append_title ="– "+title_add; 
//console.log(append_title); 
 $(this).closest(".product-form__input").find(".form__label-info").text(append_title);
  if($('.product-badge-enable-flickty').length > 0){
 $('.product-badge-enable-flickty').flickity('destroy'); 
 setTimeout(function() {
 
  $('.product-badge-enable-flickty').flickity({
                      cellAlign: 'center',  // Center align slide
                      contain: true,        // Content container ke andar rakhna
                      wrapAround: true,     // Infinite loop
                      autoPlay: 2000,       // Auto slide every 3 seconds
                      prevNextButtons: false, // Next/Previous buttons
                      pageDots: false,       // Navigation dots
                      groupCells: false 
                }).flickity('resize');
    
 },100);
  }
});
$("body").on("click","li.swatch-varaint-jtpl.list-clicked-all,.swatch-grid-style-only .swatch-grid-color-wrapper .color__swatch.color__swatch--round,.legend-grid-list-wrapper .swatch-list-style,.legend-grid-list-wrapper .swatch-grid-style",function(){
  if($('.product-badge-enable-flickty').length > 0){
 $('.product-badge-enable-flickty').flickity('destroy'); 
 setTimeout(function() {
  $('.product-badge-enable-flickty').flickity({
                      cellAlign: 'center',  // Center align slide
                      contain: true,        // Content container ke andar rakhna
                      wrapAround: true,
                      fade: true,// Infinite loop
                      autoPlay: 2000,
                      imagesLoaded: true,// Auto slide every 3 seconds
                      prevNextButtons: false, // Next/Previous buttons
                      pageDots: false,       // Navigation dots
                      groupCells: false 
                }).flickity('resize');
    
 },100);
  } 
}); 
setTimeout(function() {  
  if($('.product-badge-enable-flickty').length > 0){  
$('.product-badge-enable-flickty').flickity({
                      cellAlign: 'center',  // Center align slide
                      contain: true,        // Content container ke andar rakhna
                      wrapAround: true,
                      fade: true,
                      autoPlay: 2000,
                      imagesLoaded: true,// Auto slide every 3 seconds
                      prevNextButtons: false, // Next/Previous buttons
                      pageDots: false,       // Navigation dots
                      groupCells: false 
                });
}
},2000);
// Css using js for klarna widget Start
  var KlarnaIntervalId = setInterval(function() {
    var klarnaElement = document.querySelector('klarna-placement'); 

    if (klarnaElement) {
       var host = klarnaElement.shadowRoot.querySelector(".top-strip-promotion-auto-size");
     // alert('host'+ host);
       if (host) {
            var style = document.createElement("style");
            style.innerHTML = ".container {padding: 4px 6px; background:#fff; } .container p { white-space: nowrap; font-family: var(--font-body-family); } .container p .logo{ background: #ffb3c7; padding: 6px; border-radius: 4px; } .badge-container .badge {max-width: 36px;} .text-wrapper {margin-left: 6px;} .badge-container .badge svg {max-height: 15px;} .top-strip-promotion-auto-size p, .top-strip-promotion-auto-size p .link{ font-size: 12px !important; font-family: Helvetica, 'Helvetica Neue', Arial, 'Lucida Grande', sans-serif; color: #000;} ";
            host.appendChild(style);
            clearInterval(KlarnaIntervalId); 
        } else {
            // console.log('.top-strip-promotion-auto-size not found inside shadow DOM');
           clearInterval(KlarnaIntervalId); 
       }
    } else {
        // console.log('klarna-placement element or Shadow DOM not found');
      clearIternterval(KlarnaIntervalId); 
    }
}, 500);

// Css using js for klarna widget End

/**********************End**************************/
  
/********************Stay All Day Bold**************************/
     if($(".list-menu-child.list-menu span").length > 0){
   $(".list-menu-child.list-menu span").each(function(){ 
     var $this = $(this);
     var text = $(this).text();
          if(text.indexOf("Stay All Day®") > -1){ 
       var drawer_text = text.replace("Stay All Day®","<strong>Stay All Day<sup>®</sup></strong>"); 
        $this.html(drawer_text); 
     }
        if(text.indexOf("Correct & Perfect") > -1){ 
       var new_text = text.replace("Correct & Perfect","<strong>Correct & Perfect</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("Sculpt & Glow") > -1){ 
       var new_text = text.replace("Sculpt & Glow","<strong>Sculpt & Glow</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("One Step Correct") > -1){ 
       var new_text = text.replace("One Step Correct","<strong>One Step Correct</strong>"); 
        $this.html(new_text); 
     } 
     if(text.indexOf("Pocket Play™") > -1){ 
       var new_text = text.replace("Pocket Play™","<strong>Pocket Play<sup class='tm-jtpl'>™</sup></strong>"); 
        $this.html(new_text); 
     } 
     if(text.indexOf("Stay All Weekend™") > -1){ 
         var new_text = text.replace("Stay All Weekend™","<strong>Stay All Weekend<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("Liqua-Play™") > -1){ 
         var new_text = text.replace("Liqua-Play™","<strong>Liqua-Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("Suede Shade™") > -1){ 
         var new_text = text.replace("Suede Shade™","<strong>Suede Shade<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("NEW Made-U-Lash™") > -1){ 
         var new_text = text.replace("NEW Made-U-Lash™","<strong>NEW Made-U-Lash<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("NEW InkWear™") > -1){ 
         var new_text = text.replace("NEW InkWear™","<strong>NEW InkWear<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("NEW Pocket Play") > -1){ 
         var new_text = text.replace("NEW Pocket Play","<strong>NEW Pocket Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("NEW Smudge & Set") > -1){ 
         var new_text = text.replace("NEW Smudge & Set","<strong>NEW Smudge & Set</strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Liqua-Play") > -1){ 
         var new_text = text.replace("Liqua-Play","<strong>Liqua-Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Chroma-Flash") > -1){ 
         var new_text = text.replace("Chroma-Flash","<strong>Chroma-Flash</strong>"); 
          $this.html(new_text); 
     }
      if(text.indexOf("Heaven's Dew") > -1){ 
         var new_text = text.replace("Heaven's Dew","<strong>Heaven's Dew</strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Calligraphy") > -1){ 
         var new_text = text.replace("Calligraphy","<strong>Calligraphy</strong>"); 
          $this.html(new_text); 
     }
     if (text.indexOf("Mini HUGE™") > -1 ) {
      var new_text = text.replace("Mini HUGE™", "<span>Mini <strong>HUGE<sup class='tm-jtpl'>™</sup></strong></span>");
      $this.html(new_text);
    } else if (text.indexOf("HUGE™") > -1) {
      var new_text = text.replace("HUGE™", "<strong>HUGE<sup class='tm-jtpl'>™</sup></strong>");
      $this.html(new_text);
    }
     });
 }
  
    if($(".mega-menu__promo-content").find('.mega-menu__promo-subheading').length > 0){
     $(".mega-menu__promo-content").find('.mega-menu__promo-subheading').each(function(){ 
     var $this = $(this);
     var text = $.trim($(this).text());
     console.log("Test----",text.indexOf("InkWear™"));
     
    var new_text = text;


if (new_text.indexOf("Stay All Day®") > -1) {
  new_text = new_text.replace(/Stay All Day®/g,
    "<strong>Stay All Day<sup>®</sup></strong>"
  );
}


if (new_text.indexOf("InkWear™") > -1) {
  new_text = new_text.replace(/InkWear™/g,
    "<strong>InkWear<sup>™</sup></strong>"
  );
}

$this.html(new_text);

     
       if(text.indexOf("Correct & Perfect") > -1){ 
       var new_text = text.replace("Correct & Perfect","<strong>Correct & Perfect</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("Sculpt & Glow") > -1){ 
       var new_text = text.replace("Sculpt & Glow","<strong>Sculpt & Glow</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("One Step Correct") > -1){ 
       var new_text = text.replace("One Step Correct","<strong>One Step Correct</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("Pocket Play™") > -1){ 
       var new_text = text.replace("Pocket Play™","<strong>Pocket Play<sup class='tm-jtpl'>™</sup></strong>"); 
        $this.html(new_text); 
     } 
     if(text.indexOf("Stay All Weekend™") > -1){ 
         var new_text = text.replace("Stay All Weekend™","<strong>Stay All Weekend<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("Liqua-Play™") > -1){ 
         var new_text = text.replace("Liqua-Play™","<strong>Liqua-Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("Suede Shade™") > -1){ 
         var new_text = text.replace("Suede Shade™","<strong>Suede Shade<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
       if(text.indexOf("NEW Made-U-Lash™") > -1){ 
         var new_text = text.replace("NEW Made-U-Lash™","<strong>NEW Made-U-Lash<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("NEW InkWear™") > -1){ 
         var new_text = text.replace("NEW InkWear™","<strong>NEW InkWear<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("NEW Pocket Play") > -1){ 
         var new_text = text.replace("NEW Pocket Play","<strong>NEW Pocket Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("NEW Smudge & Set") > -1){ 
         var new_text = text.replace("NEW Smudge & Set","<strong>NEW Smudge & Set</strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Liqua-Play") > -1){ 
         var new_text = text.replace("Liqua-Play","<strong>Liqua-Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Chroma-Flash") > -1){ 
         var new_text = text.replace("Chroma-Flash","<strong>Chroma-Flash</strong>"); 
          $this.html(new_text); 
     }
      if(text.indexOf("Heaven's Dew") > -1){ 
         var new_text = text.replace("Heaven's Dew","<strong>Heaven's Dew</strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Calligraphy") > -1){ 
         var new_text = text.replace("Calligraphy","<strong>Calligraphy</strong>"); 
          $this.html(new_text); 
     }
     if (text.indexOf("Mini HUGE™") > -1 ) {
      var new_text = text.replace("Mini HUGE™", "<span>Mini <strong>HUGE<sup class='tm-jtpl'>™</sup></strong></span>");
      $this.html(new_text);
    } else if (text.indexOf("HUGE™") > -1) {
      var new_text = text.replace("HUGE™", "<strong>HUGE<sup class='tm-jtpl'>™</sup></strong>");
      $this.html(new_text);
    }
   }); 
  }

   if($(".menu-drawer__menu").find('.menu-drawer__menu-item').length > 0){
     $(".menu-drawer__menu").find('.menu-drawer__menu-item').each(function(){ 
     var $this = $(this);
     var text = $.trim($(this).text());
     
     if(text.indexOf("Stay All Day®") > -1){ 
       var new_text = text.replace("Stay All Day®","<strong>Stay All Day<sup>®</sup></strong>"); 
        $this.html(new_text); 
     } 
     if(text.indexOf("Correct & Perfect") > -1){ 
       var new_text = text.replace("Correct & Perfect","<strong>Correct & Perfect</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("Sculpt & Glow") > -1){ 
       var new_text = text.replace("Sculpt & Glow","<strong>Sculpt & Glow</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("One Step Correct") > -1){ 
       var new_text = text.replace("One Step Correct","<strong>One Step Correct</strong>"); 
        $this.html(new_text); 
     }
       if(text.indexOf("Pocket Play™") > -1){ 
       var new_text = text.replace("Pocket Play™","<strong>Pocket Play<sup class='tm-jtpl'>™</sup></strong>"); 
        $this.html(new_text); 
     } 
     if(text.indexOf("Stay All Weekend™") > -1){ 
         var new_text = text.replace("Stay All Weekend™","<strong>Stay All Weekend<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("Liqua-Play™") > -1){ 
         var new_text = text.replace("Liqua-Play™","<strong>Liqua-Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("Suede Shade™") > -1){ 
         var new_text = text.replace("Suede Shade™","<strong>Suede Shade<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
       if(text.indexOf("NEW Made-U-Lash™") > -1){ 
         var new_text = text.replace("NEW Made-U-Lash™","<strong>NEW Made-U-Lash<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     } 
     if(text.indexOf("NEW InkWear™") > -1){ 
         var new_text = text.replace("NEW InkWear™","<strong>NEW InkWear<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("NEW Pocket Play") > -1){ 
         var new_text = text.replace("NEW Pocket Play","<strong>NEW Pocket Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("NEW Smudge & Set") > -1){ 
         var new_text = text.replace("NEW Smudge & Set","<strong>NEW Smudge & Set</strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Liqua-Play") > -1){ 
         var new_text = text.replace("Liqua-Play","<strong>Liqua-Play<sup class='tm-jtpl'>™</sup></strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Chroma-Flash") > -1){ 
         var new_text = text.replace("Chroma-Flash","<strong>Chroma-Flash</strong>"); 
          $this.html(new_text); 
     }
      if(text.indexOf("Heaven's Dew") > -1){ 
         var new_text = text.replace("Heaven's Dew","<strong>Heaven's Dew</strong>"); 
          $this.html(new_text); 
     }
     if(text.indexOf("Calligraphy") > -1){ 
         var new_text = text.replace("Calligraphy","<strong>Calligraphy</strong>"); 
          $this.html(new_text); 
     }
     if (text.indexOf("Mini HUGE™") > -1 ) {
      var new_text = text.replace("Mini HUGE™", "<span>Mini <strong>HUGE<sup class='tm-jtpl'>™</sup></strong></span>");
      $this.html(new_text);
    } else if (text.indexOf("HUGE™") > -1) {
      var new_text = text.replace("HUGE™", "<strong>HUGE<sup class='tm-jtpl'>™</sup></strong>");
      $this.html(new_text);
    }
 });
 }
  /**********************End**************************/  
/**********************End**************************/

 //   $('body').on('click', '.pr-snippet-review-count', function(event) {
 //     //event.preventDefault();
 //      $('html, body').animate({
 //          scrollTop: $("#pr-reviewdisplay").offset().top -100
 //      }, 500);
 // });
   if($("body").hasClass("template-product")){
    var handleReview = setInterval(ReviewBlock,500);
     function ReviewBlock(){
       if($(".pr-snippet-rating-decimal").length > 0){
          var url = $(".pr-snippet-write-review-link").attr("href");
          $("#write-a-review .pr-snippet-review-count").attr("href",url);
          var get_count = parseInt($(".pr-snippet-rating-decimal").text());
          if(get_count > 0 ){
          $("div#write-a-review").attr("style","display:none");
          }else{
          $("div#write-a-review").attr("style","display:block");
          } 
         clearInterval(handleReview);
        }
     
      }

   }
  
/*************Shop the Look Start**********************/
if($("shop-the-look").length > 0){
  $(".product-container-jtpl[data-variant]").each(function(){
    var $this2 = $(this);
      var shop_variant =  $this2.attr("data-variant");
      var shop_color =  $this2.attr("data-sel-option");
     var productHandle =  $this2.attr("data-product-handle");
   // console.log($this2.find(".color-swatch[title='"+shop_color+"']"));
    
    var evObj = document.createEvent( 'Events' );
            evObj.initEvent( "mouseenter", true, false );
            document.querySelector( '.product-container-jtpl[data-sel-option="'+shop_color+'"] .color-swatch[title="'+shop_color+'"]' ).dispatchEvent( evObj );
       // $this2.find(".color-swatch[title='"+shop_color+"']").trigger("click");
    // return false;   
    
  });
}



  
 /*************Shop the Look End**********************/
 
$(".icon-jtpl-down").on("click", function() {
  var currentPosition = $(".thumbnail-list").scrollTop();
  var currentPositionNew = currentPosition + 300;
  $(".thumbnail-list").scrollTop(currentPositionNew);
});


$(".icon-up-jtpl ").on("click", function() {
  var currentPosition = $(".thumbnail-list").scrollTop();
  var currentPositionNew = currentPosition - 300;
  $(".thumbnail-list").scrollTop(currentPositionNew);
});
resizeArrPDP();
 function resizeArrPDP(){
 // console.log($('.thumbnail-list.custom_slider_jtpl').find("li").length +"==="+$(window).width());
    if($(window).width() > 1320){
     if($('.thumbnail-list.custom_slider_jtpl').find("li").length > 7){
       $(".icon-jtpl-down").show();
        $(".icon-up-jtpl").show();
     }else{
         $(".icon-jtpl-down").hide();
        $(".icon-up-jtpl").hide();
     }
  }else{
    if($('.thumbnail-list.custom_slider_jtpl').find("li").length > 5){
       $(".icon-jtpl-down").show();
        $(".icon-up-jtpl").show();
     }else{
         $(".icon-jtpl-down").hide();
        $(".icon-up-jtpl").hide();
     }
  }
 }
  if($('.thumbnail-list.custom_slider_jtpl').length > 0){
var scrollTop = $('.thumbnail-list.custom_slider_jtpl').scrollTop();
  if (Math.round(scrollTop + $(this).innerHeight()) >= this.scrollHeight) {
      $('.icon-jtpl-down').addClass('disable-icon');
     $('.icon-up-jtpl').removeClass('disable-icon');
  } else if (scrollTop <= 0) {
     $('.icon-jtpl-down').removeClass('disable-icon');
    $('.icon-up-jtpl').addClass('disable-icon');
}  

  }
$('.thumbnail-list.custom_slider_jtpl').on('scroll', function() {
  var scrollTop = $(this).scrollTop();
    //console.log(Math.round(scrollTop + $(this).innerHeight()) +'='+ this.scrollHeight)
  if (Math.round(scrollTop + $(this).innerHeight()) >= this.scrollHeight) {
      $('.icon-jtpl-down').addClass('disable-icon');
     $('.icon-up-jtpl').removeClass('disable-icon');
  } else if (scrollTop <= 0) {
     $('.icon-jtpl-down').removeClass('disable-icon');
    $('.icon-up-jtpl').addClass('disable-icon');
  } else {
    
  }
});

  
  var zinrelo = setInterval(zinreloTab,1000);
  function zinreloTab(){
     if( $(".zinrelo-tab").length > 0){
     $(".zinrelo-tab").removeAttr("style"); 
       clearInterval(zinrelo);
      } 
    if($("#cancel_redemption_after").length > 0){
      var cancel_html = $("#cancel_redemption_after").text();
      var cancelhtml = cancel_html.replace(".00","");
      $("#cancel_redemption_after").text(cancelhtml);
    }
  }

  
  setTimeout(function(){
  if($("shop-login-button").length > 0){ 
    var host = document.querySelector("shop-login-button").shadowRoot.querySelector('shop-follow-button').shadowRoot.querySelector ("follow-on-shop-button");var style = document.createElement( 'style' );
    style.innerHTML = '.follow-icon-wrapper:before { background: rgb(var(--color-button-background)); } .button:not(.button--following):hover .follow-icon-wrapper:before  { background: rgb(var(--color-button-background)); } ';
    host.shadowRoot.appendChild( style );
  }
    },500);
  
  
  
  if(window.location.href.indexOf("products") > -1){
    
  document.addEventListener('variant:change', function(evt) {
    // console.log(evt.detail.variant);
    var value_try =  evt.detail.variant.id;
    $(".try-it-on-swatch.try-val-"+value_try).trigger('click');
  });
    
   
   $(window).resize(function() {
     resizeArrPDP();
      if ($(window).width() < 768) {
       $('body').find('.custom-youtube-url-jtpl').addClass("mobile-View");
        $('body').find('.custom-youtube-url-jtpl').removeClass("product__modal-opener");
      }else {
          $('body').find('.custom-youtube-url-jtpl').addClass("product__modal-opener");
          $('body').find('.custom-youtube-url-jtpl').removeClass("mobile-View");
      }
   });
    $(".custom-youtube-url-jtpl").click(function(e){
       e.preventDefault();
      $('.jtpl__youtube_popup').show();
       $(".popup").toggleClass("active-pop");
       $(".popup").fadeIn(300,function(){$(this).focus();});
       $('body').addClass("custom-overly-jtpl");
      var data = $("#frame-product-video").attr("data-src");
       $("#frame-product-video").attr("src",data);
    });
    
    $('.custom_popup_jtpl .quick-view__close').click(function(){
      $('.jtpl__youtube_popup').hide();
      $('body').removeClass("custom-overly-jtpl");
      $(".popup").toggleClass("active-pop");
      $(".popup").fadeOut(300);
      $("#frame-product-video").attr("src","");
    });

    $(document).on("click","body.custom-overly-jtpl" , function (e){
     e.preventDefault();
     if($(e.target).closest(".popup").hasClass("active-pop")) {
        $('body').removeClass("custom-overly-jtpl");
        $('.jtpl__youtube_popup').hide();
        $(".popup").removeClass("active-pop");
    }
      
});

}
 
 
 
  


  
 if($(".mini-cart--open .free-sample-main-section").length>0)
 {
    $(document).on('click','.free-sample-atc-jtpl',function(){ 
      var product_id = $(this).attr("product-atc-id");
        $(this).hide();
        $(this).siblings(".free-sample-remove-jtpl").show()
       var properties = {};
        var GT_Data_Id = [];
      GT_Data_Id.push(product_id);
          properties["_free_sample_product"] = "free_sample_product";
       
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'JSON',
        data: {id:GT_Data_Id , quantity:1, properties : properties},
        success: function(){
          window.location.assign('/cart');
        },
        error: function(){
          console.log("error")
        }
      });
   });
         $(document).on('click','.free-sample-remove-jtpl',function(){ 
      var product_id = $(this).attr("product-rmv-id")
            $(this).hide();
           $(this).siblings(".free-sample-atc-jtpl").show()
            jQuery.ajax({
              type: 'POST',
              url: '/cart/change.js',
              async: false,
              data:{
                id: product_id,
                quantity: 0
              },
              dataType: 'json',
              success: function(){
                window.location.assign('/cart');
              },
             error: function(error){
              console.log(error);   
            },
          });
       });
   
       $(document).on('click','button.modal-opener-free-sample',function(e){ 
         e.preventDefault();
      $(".data-modal-show").html('');
     $("body").addClass("quick-large-open");
     var modalData = $(this).parents(".total-modalninfo").find(".data-to-upload-jtpl").html();
       console.log('show');
       $(".data-modal-show").html(modalData);
   });
         $(document).on('click','.modal_close-jtpl',function(e){ 
     e.preventDefault();
      $(".data-modal-show").hide();
      $("body").removeClass("quick-large-open");
   });
      $(document).on('click','.checkout__cart',function(){ 
        //  jQuery.getJSON('/cart.js', function(cart) {
        //  console.log(cart);
        //   if( cart.total_price <= 0   ){
        //    // $(".checkout-btn").prop("disabled", true);
        //     // window.location.href='/cart/clear';
        //     // $('.checkout-btn').after('<p style="color:red;">You must add merchandise before you can proceed to checkout.</p>');
        //     return false;    
        //  }
        // });
      $(".data-modal-show").hide();
      $("body").removeClass("quick-large-open");
   });
   $(document).on('click','.buy-atc-large',function(e){ 
      e.preventDefault();
      var product_id = $(this).attr("product-atc-id-large");
      var GT_Data_Id = [];
      GT_Data_Id.push(product_id);
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'JSON',
        data: {id:GT_Data_Id , quantity:1 },
        success: function(){
          // $('.modal_close-jtpl').trigger("click");
          window.location.assign('/cart');
        },
        error: function(){
          console.log("error")
        }
      });
   });
   $(document).on('click','.var-swatch-img-jtpl',function(e){ 
       e.preventDefault();
       $(".var-swatch-img-jtpl").removeClass("active-swatch");
       var product_id = $(this).attr("data-vvid");
       var var_img = $(this).attr("var-img-src");
       var var_title = $(this).attr("var-title-jtpl");
         $(this).parents(".modal_body-jtpl").find("span.clr-ttl-jtpl").html(var_title);
       $(this).parents(".modal_body-jtpl").find(".main-media-modal img").attr("src",var_img);
       $(this).addClass("active-swatch");
       $(this).parents(".modal_body-jtpl").find(".main-full-btn-jtpl a").attr("product-atc-id-large",product_id);
   });
   
}

  
  
 
$(document).on('click','.free-product-varient img',function(e){
  e.preventDefault();
  var src = $(this).attr("data-src");
  $(this).parents(".gift_item").find(".product-media img").attr("src",src);
    $('.free-product-varient img').removeClass('selected');
    $(this).addClass('selected');
});
  
  // check box functionality
  // product image size give to thunbnail
  $(document).on('load resize scroll', function(){
      var imageWidth = $('.template-product .product .product__media-list li').width();
      var ttlWidth = imageWidth - 60;
      $('.thumbnail-slider.with-youtube-link .jtpl__thumbnail_slider, .thumbnail-slider.with-youtube-link .jtpl__thumbnail_slider .jtpl_slider_inner, .thumbnail-slider.with-youtube-link .jtpl__thumbnail_slider .jtpl_slider_inner .thumbnail-list').css('max-width', ttlWidth);
  });
  $(document).ready(function(){
      $('.thumbnail-slider .jtpl_youtube_icon').each(function(){
          $(this).closest('.thumbnail-slider').addClass('with-youtube-link');
      });
  });

  
  $('.readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';window.scrollTo({top: 110, behavior: 'smooth'});
  })


  
  $('.readmore_mobile').click(function (event) {
    event.preventDefault();
    var descriptionFull_mobile = document.querySelector('.product-description-full_mobile');
    descriptionFull_mobile.style.display = 'block';
    var descriptionShort_mobile = document.querySelector('.product-description-short_mobile');
    descriptionShort_mobile.style.display = 'none';
  });
  $('.readless_mobile').click(function (event) {
    event.preventDefault();
    var descriptionFull_mobile = document.querySelector('.product-description-full_mobile');
    descriptionFull_mobile.style.display = 'none';
    var descriptionShort_mobile = document.querySelector('.product-description-short_mobile');
    descriptionShort_mobile.style.display = 'block';window.scrollTo({top: 110, behavior: 'smooth'});
  })
  


  
  setTimeout(function(){
     if ($('iframe#launcher')[0]) {
        $('body').addClass('chat_bot_cstm');
    }
  }, 4000);

  
  $(".swatch-selected-color.active").click(function() {
      $('.try-on-original-selector').trigger('click');
  });
});


 
document.addEventListener("DOMContentLoaded", (event) => {
    addClassbtn();
    function addClassbtn() {
        var url = window.location.href;
        if (url.indexOf("/cart") > -1) {
            $("#redeem_zrl_reward").addClass("button--secondary button--secondary-solid");
            $(".zrl-modal-footer").find('#zrl-continue-redemption').addClass("button--secondary button--secondary-solid");
            $(".zrl-modal-footer").find('#zrl-cancel-redemption').addClass("button--secondary button--secondary-solid");
            $("#zrl-reward-error").find('.button').addClass("button--secondary button--secondary-solid");
        }
    }
});
 

/****************** Store locator app js start ********************/
document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        var filterButton = document.querySelector(".storerocket-filter-button");
        if (filterButton) {
            filterButton.click();
        }
    }, 4000); 
});
/************* Store locator app js end ********************/

/************* scroll to section js start ********************/
$('body').on('click', ".cstm-redirection-section", function(event){
    event.preventDefault();
  var dataToScroll = $(this).attr("page-data")
    $('html, body').animate({
        scrollTop: $("."+dataToScroll).offset().top - 100
    }, 1000);
});
/************* scroll to section js end ********************/

// /************* Cstm-tabs-button js start ********************/
// $( document ).ready(function() { 
// $('.cstm_accordion__title').on('click', function() {
//     var dataIndex = $(this).attr("data-index");
//             console.log(dataIndex);
//               $(".cstm_accordion__content").hide();
//             $(dataIndex).show()
//   });
// });
// /************* Cstm-tabs-button js end ********************/

$(".media--hover-effect.card--image-animate .motion-reduce").mouseover(function(){
     $(this).parents(".card-wrapper").find(".badge-inner-col-jtpl").css("display", "none");
  });
  $(".media--hover-effect.card--image-animate .motion-reduce").mouseout(function(){
     $(this).parents(".card-wrapper").find(".badge-inner-col-jtpl").css("display", "block");
  });
////************************************************** BUY X GET X SECTION BEGIN. **********************************************************////

   var Free_Items_bottom = [];

$(document).ready(function() {
    if ($(".cstm_collection_banner").find("img").length > 0) {
        $("body").addClass("page-with-collection-banner");
    }

    $('.checkout__cart').attr('disabled', false);

    $(document).on('click', '.remove', function() {
        $('.checkout__cart').attr('disabled', true);
    });

    $(document).ready(function() {
         $('.quantity-wrapper.border-radius-sharp').find('.increase-quantity').on('click', function() {
              var quantityInput = $('.bundle-pro-bundle');
              var currentValue = parseInt(quantityInput.val());
              quantityInput.val(currentValue + 1);
          });
  
         $('.quantity-wrapper.border-radius-sharp').find('.decrease-quantity').on('click', function() {
              var quantityInput = $('.bundle-pro-bundle');
              var currentValue = parseInt(quantityInput.val());
              if (currentValue > 1) {
                  quantityInput.val(currentValue - 1);
              }
          });
      });

    $(document).on('click', '.pro-bundle-button', function(e) {
        e.preventDefault();
        var bundle_idd = $(this).siblings('.pro-bundle-hide').attr('product__id');
        var bundle_qty = $(this).siblings('.quantity-wrapper.border-radius-sharp').find('.selected_val_quantity').val();
        $(this).parents('.product-detail__form__action').addClass('top-slected-wrp');

        if (bundle_qty > 1) {
            $('.free-hide-label').attr('free_qty', bundle_qty);
            $('.step_text_wp.step_2 p em').html(bundle_qty);

            setTimeout(function() {
                $('[details_all_values]').flickity({
                    pageDots: false,
                    wrapAround: false,
                    arrows: true,
                    prevArrow: '<span class="slide-arrow prev-arrow"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline><title>svg</title></svg> </span>',
                    nextArrow: '<span class="slide-arrow next-arrow"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline><title>svg</title></svg></span>',
                    cellAlign: 'left', 
                    contain: true
                });
            }, 50);

            $('.bundle-free-product-cell').removeClass('jtpl_hidden');


            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'JSON',
                data: { id: bundle_idd, quantity: bundle_qty },
                success: function() {
                    console.log('success');
                },
                error: function() {
                    console.log('fail');
                }
            });

            $('html, body').animate({ scrollTop: $('.bundle-free-product-cell').offset().top - 50 }, 'slow');
        } else {
            alert("Please add at least two eye liners!");
            console.log("small");
        }
    });

    $(document).on('click', '.free-pro-image a', function(e) {
        e.preventDefault();
        var $parent = $(this).parents('.free-product-cell-inner');
        if ($parent.find('.choose-to-add-bundle').hasClass('jtpl_hidden')) {
            $parent.find('.check-image-jtpl').trigger('click');
        } else {
            $parent.find('.choose-to-add-bundle').trigger('click');
        }
    });

    $(document).on('click', '.free-bundnle-select span', function() {
        var $select = $(this).parents('.free-bundnle-select');
        $select.addClass('free_selected_wp');
        $(this).toggleClass('jtpl_hidden');
        $(this).siblings('.check-image-jtpl').toggleClass('jtpl_hidden');

        var free_check_count = $('.free-bundnle-select.free_selected_wp').length;
        var chk_select_id = $('.free-hide-label').attr('free_qty');
      
        if (free_check_count > 1) {
            if (chk_select_id == free_check_count) {
                $('.free-pro-check').removeClass('chk_pro_wrap_jt');
                $('.free-pro-image').addClass('img_click_disable');
                $('.cart-drawer-btn').removeClass('jtpl_hidden');
                $('html, body').animate({ scrollTop: $('.cart-drawer-btn').offset().top - 500 }, 'slow');
            } else {
                $('.free-pro-check').addClass('chk_pro_wrap_jt');
                $('.free-pro-image').removeClass('img_click_disable');
            }
        } else {
            $('.cart-drawer-btn').addClass('jtpl_hidden');
        }
    });


  

    $(document).on('click', '.free-bundnle-select img', function() {
        var $select = $(this).parents('.free-bundnle-select');
        $select.removeClass('free_selected_wp');
        $(this).toggleClass('jtpl_hidden');
        $(this).siblings('.free-bundnle-select span').toggleClass('jtpl_hidden');

        var free_check_count2 = $('.free-bundnle-select.free_selected_wp').length;
        var chk_select_id2 = $('.free-hide-label').attr('free_qty');

        if (free_check_count2 >= 2) {
            $('.cart-drawer-btn').removeClass('jtpl_hidden');

            if (chk_select_id2 == free_check_count2) {
                $('.free-pro-check').removeClass('chk_pro_wrap_jt');
                $('.free-pro-image').addClass('img_click_disable');
            } else {
                $('.free-pro-check').addClass('chk_pro_wrap_jt');
                $('.free-pro-image').removeClass('img_click_disable');
            }
        }
    });

    $(document).on('click', '[show-bundle-btn_clk]', function() {
        var free_id_get = $(this).siblings('.free-hide-label').val();
    });

    $(document).on('click', '.select_top_wp', function() {
        var free_varient_img_top = $(this).children('option:selected').attr('data-src-img');
        var free_varient_id_top = $(this).val();

        $(this).parents('.pro-details-top').find('.varient_top_image').attr('src', free_varient_img_top);
        $(this).parents('.pro-details-top').siblings('.pro-details-bottom').find('.pro-bundle-hide').attr('product__id', free_varient_id_top);
    });

    $(document).on('click', '.bundle_free_drop', function() {
        var free_varient_id_bottom = $(this).val();
        var free_varient_img_bottom = $(this).children('option:selected').attr('data-src-img');

        $(this).parents('.free-product-cell-inner').find('.free-bundnle-select').attr('free_id', free_varient_id_bottom);
        $(this).parents('.free-product-cell-inner').find('.varient_select_image_bottom').attr('src', free_varient_img_bottom);
    });



function Opencartdrawer() {
  $("body").addClass("mini-cart--open");
  $('.header-wrapper').find('.cart-drawer-container').attr('open', true); 
  $('.header-wrapper').find('.cart-drawer-container').addClass('menu-opening');
}
    

    var GT_Data_Id = [];

    $(document).on('click', '[bundle_show_clk]', function() {
      
        $('.free_selected_wp').each(function() {
            var id_bottom = $(this).attr('free_id');
            GT_Data_Id.push(id_bottom);
            var properties = { "_bundle_free": "free" };

            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'JSON',
                data: { id: GT_Data_Id, quantity: 1, properties: properties },
                success: function(data) {
                   // console.log("here 1");
                  Opencartdrawer();
                   updateCart();
                  //  window.location.assign('/cart');
                },
                error: function() {
                    console.log("error");
                }
            });
        });
    });
});
////************************************************** BUY X GET X SECTION END. **********************************************************////


// document.addEventListener("DOMContentLoaded", (event) => { 
//     if($('[data-fancybox="gallery"]').length > 0){
//   $('[data-fancybox="gallery"]').fancybox({
//       toolbar: true, 
//       smallBtn: true, 
//       protect: true 
//   });
//       }
// });

